<div class="card p-0 m-0 shadow-none">
  <div class="card-body pb-0">
    <div class="d-flex gap-2 w-100 align-content-center">
      <div class="flex-grow-1">
        <div class="d-flex align-items-center">
          <div class="flex-grow-1">
            <h4 class="card-header-title">
              {{ step === 1 ? 'Rotate' : 'Crop' }} Image
            </h4>
          </div>
        </div>
      </div>

      <div class="flex-shrink-0">
        <!--
        <button (click)="close()" type="button" class="btn text-black">
          <i class="mdi mdi-close-thick align-middle"></i>
        </button>-->
      </div>
    </div>
  </div>
  <div class="card-body">
    <div *ngIf="step === 1">
      <div align="center">
        <img
          height="190"
          width="175"
          class="img-fluid my-rotation"
          [src]="media.url"
          [style.transform]="'rotate(' + '-' + rotation + 'deg)'"
          alt="Rotated Image" />

        <div class="mt-2 d-flex justify-content-center">
          <img
            role="button"
            width="33"
            src="assets/images/digital-signage/tleft.png"
            alt="Turn Left"
            (click)="rotateLeft()" />
          <img
            role="button"
            width="33"
            class="ms-2"
            src="assets/images/digital-signage/tright.png"
            alt="Turn Right"
            (click)="rotateRight()" />
        </div>
      </div>

      <div class="p-3 border-top text-end">
        <button
          class="btn btn-primary ms-3"
          (click)="onSubmitRotation()"
          type="submit">
          Done
        </button>
      </div>
    </div>

    <div *ngIf="step === 2">
      <div class="row">
        <div class="col-12">
          <div class="cropper-wrapper">
            <image-cropper
              format="jpeg"
              (imageCropped)="imageCropped($event)"
              (imageLoaded)="imageLoaded($event)"
              [imageFile]="media.file ?? undefined"
              [imageURL]="rotateUrl!"
              [aspectRatio]="size.aspectRatio ?? 1"></image-cropper>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col-auto ms-auto">
            <button (click)="success()" class="btn btn-soft-primary">
              Crop
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
